<template>
  <div>
    <ChartInteraction></ChartInteraction>

    <b-card body-class="p-0" header-class="border-0">
      <transaction-search-results
        :query="{
          statuses: ['APPROVED', 'DECLINED'],
          currentPage: 1,
          modules: [
            'TEXTTOPAY',
            'PAYMENTPLAN',
            'MEMBERSHIP',
            'TERMINAL',
            'VIRTUALTERMINAL',
            'PAYMENTPAGE',
          ],
          sortOption: 'Date:descending',
        }"
      ></transaction-search-results>
    </b-card>
  </div>
</template>
<script>
import { hasRole } from "@/services/configService.js";

import TransactionSearchResults from "@/views/Components/Transactions/SearchResults.vue";

import ChartInteraction from "@/views/Components/Dashboard/ChartInteraction.vue";

export default {
  title: "Dashboard",
  inject: ["hasRole"],
  components: {
    ChartInteraction,
    TransactionSearchResults,
  },
  data() {
    return {
      hasPageOrphans: true,
      showChart: true,
    };
  },
  created() {},
  methods: {
    setOrphanState(count) {
      if (count > 0) {
        this.hasPageOrphans = true;
      } else {
        this.hasPageOrphans = false;
      }
    },
    async associated(orphans) {
      if (orphans.length == 0) this.hasPageOrphans = false;

      this.$emitter.emit("bind-transactions");
      this.bind();
    },
  },
};
</script>
<style></style>
